import { Link } from 'react-router-dom';
import ProductCard from '@/components/base/ProductCard';
import { products } from '@/mocks/products';

export default function BestsellersCarousel() {
  const bestsellers = products.filter(p => p.isBestseller).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
              What Everyone's Talking About
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">Our most-loved toys, backed by happy pets and their humans</p>
          </div>
          <Link
            to="/shop?sort=bestseller"
            className="hidden sm:inline-flex items-center gap-1.5 text-accent-500 font-semibold text-sm hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            View All
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide snap-x snap-mandatory">
          {bestsellers.map(product => (
            <div key={product.id} className="flex-shrink-0 w-[250px] sm:w-[260px] md:w-[280px] snap-start">
              <ProductCard product={product} />
            </div>
          ))}
        </div>

        <Link
          to="/shop?sort=bestseller"
          className="sm:hidden mt-6 inline-flex items-center gap-1.5 text-accent-500 font-semibold text-sm"
        >
          View All Bestsellers
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </section>
  );
}